import React, { useState } from 'react';

interface SelectEraListSheetProps {
  eraCategoryList: EraCategory[];
  selectedEraCategory: EraCategory;
  setSelectedEraCategory: (eraCategory: EraCategory) => void;
  closeSheet: () => void;
}

export const SelectEraListSheet: React.FC<SelectEraListSheetProps> = ({
  eraCategoryList,
  selectedEraCategory,
  setSelectedEraCategory,
  closeSheet,
}) => {
  const [currentEraCategory, setCurrentEraCategory] = useState<EraCategory>(selectedEraCategory);
  const hadleClickEra = (eraCategory: EraCategory) => {
    setCurrentEraCategory(eraCategory);
    setSelectedEraCategory(eraCategory);
    closeSheet();
  };

  return (
    <div className="flex flex-col gap-3">
      {eraCategoryList.map(eraCategory => {
        const isSelected = currentEraCategory.eraCategoryId === eraCategory.eraCategoryId;

        return (
          <button
            key={eraCategory.eraCategoryId}
            onClick={() => hadleClickEra(eraCategory)}
            style={{
              boxShadow: `0px 2px 0px 0px ${isSelected ? '#53C6FF' : '#E5E5E5'}`,
              border: `1.5px solid ${isSelected ? '#53C6FF' : '#E5E5E5'}`,
            }}
            className={`flex items-center justify-between py-4 px-5 rounded-xl cursor-pointer transition-all duration-200 border-2 active:scale-[0.98]`}
          >
            <div className="text-base font-semibold text-gray-800">{eraCategory.categoryName}</div>
            <div className="text-sm text-gray-500 mr-3">{eraCategory.period}</div>
            {isSelected && <div className="text-xl text-blue-500 font-bold">✓</div>}
          </button>
        );
      })}
    </div>
  );
};
